<div class="timer">
    <div *ngIf="inicioEleicao == false">
        <h4> Ainda faltam </h4>
        <span id="days"> {{daysToDday}} </span>Dia(s)
        <span id="hours"> {{hoursToDday}} </span>Hrs 
        <span id="minutes"> {{minutesToDday}} </span>Min
        <span id="seconds"> {{secondsToDday}} </span>S
        <h4> para o início da eleição. </h4>
    </div>
    <div *ngIf="inicioEleicao == true">
        <h2> A eleição pode ser iniciada pelo gestor!</h2>
        <h4> Em caso de início automatizado, fora realizado.</h4>
        <span id="days"> {{daysToDday}} </span>Dia(s)
        <span id="hours"> {{hoursToDday}} </span>Hrs 
        <span id="minutes"> {{minutesToDday}} </span>Min
        <span id="seconds"> {{secondsToDday}} </span>S
    </div>
    
</div>